export default class NonIntegerError extends Error {
    constructor(propertyName: string, receivedValue: number) {
        super(
            `${propertyName} parameter is not an integer. ${propertyName} must be a whole number. Received: "${receivedValue}"`
        );
        this.name = this.constructor.name;
    }
}
